import React from 'react'
import recharts from './recharts'
const {
  BarChart: BarRechart,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  Bar
} = recharts

const BarChart = ({data}) => {
  return (
    <BarRechart
      width={769}
      height={230}
      data={data}
      // margin={{
      //   top: 5, right: 30, left: 20, bottom: 5,
      // }}
      barSize={10}
    >
      <CartesianGrid strokeDasharray="1 1" height={20} />
      <XAxis dataKey="name" tick={{fontSize: 11, marginTop: 12}} dy={10}/>
      <YAxis width={50} tick={{fontSize: 11, margin: {top: 12}}} dx={-20}/>
      <Tooltip />
      <Legend iconType="circle" iconSize={10} verticalAlign="top" align="right" wrapperStyle={{paddingBottom: 20, fontSize: '11px', color: '#444'}}/>
      <Bar dataKey="baseline" fill="#FF5448"/>
      <Bar dataKey="endline" fill="#52BAE2"/>
    </BarRechart>
  )
}

export { BarChart }
